import script from "./CpitnModalWindow.vue?vue&type=script&setup=true&lang=ts"
export * from "./CpitnModalWindow.vue?vue&type=script&setup=true&lang=ts"

import "./CpitnModalWindow.vue?vue&type=style&index=0&id=01c22554&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-01c22554"]])

export default __exports__